import { buildAuthorizationContext, isAuthorizationDocumentId, isTenantPermission, isRoleScopePolicy, normalizeTenantRolePermissions, normalizeManagedTeamIds } from "./authorization"
import type { Role } from "./types/entities"

/** No default role, scope, permission set, or platform identity is inferred. */
export const resolveAssignedTenantRole = (
  userId: string,
  role: Role,
  assignment: Record<string, unknown> | undefined,
): Role | null => {
  if (!isAuthorizationDocumentId(userId) || !isAuthorizationDocumentId(role.id) || assignment?.role !== role.id) return null
  if (!Object.prototype.hasOwnProperty.call(role, "scopePolicy")) {
    if (!Array.isArray(role.permissions)) return null
    // Legacy tenant wildcard is never a platform credential. Preserve explicit
    // permissions until that role's migration has been reviewed.
    return { ...role, permissions: role.permissions.filter(isTenantPermission) }
  }
  const permissions = normalizeTenantRolePermissions(role.permissions, role.scopePolicy)
  const managedTeamIds = normalizeManagedTeamIds(assignment.managedTeamIds)
  if (!isRoleScopePolicy(role.scopePolicy) || !permissions || !managedTeamIds) return null
  const authorization = buildAuthorizationContext({
    tenantId: "display-context", actorUserId: userId,
    role: { id: role.id, permissions, scopePolicy: role.scopePolicy },
    assignment: { userId, roleId: role.id, managedTeamIds },
  })
  return authorization ? { ...role, permissions: authorization.permissions } : null
}
